export const BUILD = {branch: "master", date: "1.may 04:10"};